<template>
    <div v-if="$store.state.show">
        <div class="screening">
            <div class="filter">
                <div class="title">领域</div>
                <div class="radio">
                    <el-radio-group
                    v-model="radio1"
                    @change="getField">
                        <el-radio-button label="全部"></el-radio-button>
                        <el-radio-button
                        v-for="item in $store.state.nav"
                        :key="item.field"
                        :label="item.field"
                        :disabled="onclick != true ? true : false"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>

            <div class="filter">
                <div class="title">类目</div>
                <div class="radio">
                    <el-radio-group
                    v-model="radio2"
                    @change="getCategory">
                        <el-radio-button label="全部"></el-radio-button>
                        <el-radio-button
                        v-for="item in $store.state.nav2"
                        :key="item"
                        :label="item"
                        :disabled="onclick != true ? true : false"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>
			<div class="filter" style="overflow: visible;">
				<div class="title">地区</div>
				<div class="radio">
					<!-- <el-radio-group
						v-model="radio3"
						@change="getdistrict"
					> -->
						<!-- <el-radio-button label="全部"></el-radio-button> -->
						<!-- <area-select 
							v-model="selected" 
							:data="pca"
							:level='0'
							@change="getareaselect"
						></area-select> -->
						<el-select v-model="areaData" placeholder="请选择" @change="getareaselect">
							<!-- 省 -->
							<el-option
								v-for="item in pca[86]"
								:key="item"
								:label="item"
								:value="item"
								:disabled="onclick2 != true ? true : false"
							>
							</el-option>
							
						</el-select>
						<el-select style="margin-left: 20px;" v-model="areaData2" placeholder="请选择" @change="getareaselect2">
							<!-- 市 -->
							<el-option
								v-for="item in edata"
								:key="item"
								:label="item"
								:value="item"
								:disabled="onclick2 != true ? true : false"
							>
							</el-option>
						</el-select>
						<!-- <el-radio-button
							v-for="item in $store.state.nav3"
							:key="item"
							:label="item"
							:disabled="onclick != true ? true : false"
						>
						</el-radio-button> -->
						
					<!-- </el-radio-group> -->
				</div>
			</div>
        </div>

        <div
        class="screening"
        style="padding: 10px 20px; margin-top: 0px;">
            <div class="letter">
                <a
                v-for="(i, index) of letter"
                :key="index"
                :class="{current:index == current}"
                @click="getLetter(index)">
                {{i}}</a>
            </div>
        </div>

        <div class="mobile-select">
            <el-select
            v-model="radio1"
            placeholder="请选择领域"
            @change="getField">
                <el-option
                label="全部"
                value="全部">
                </el-option>
                <el-option
                v-for="item in $store.state.nav"
                :key="item.field"
                :label="item.field"
                :value="item.field">
                </el-option>
            </el-select>

            <el-select
            v-model="radio2"
            placeholder="请选择类目"
            @change="getCategory">
                <el-option
                label="全部"
                value="全部">
                </el-option>
                <el-option
                v-for="item in $store.state.nav2"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>

            <el-select
            style="flex: 0 0 20%;"
            v-model="zm"
            placeholder="请选择首字母"
            @change="getLetter2">
                <el-option
                v-for="item in letter"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
	import{pca, pcaa} from 'area-data'
export default {
    name: 'Screening',
    data() {
        return {
            radio1: '',
            radio2: '',
			radio3: '',
			selected:'',
			pca: pca,
			pcaa: pcaa,
			edata:'',
			mdata:'',
			areaData:'',
			areaData2:'',
			provinceName:'',
            letter: ['All', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            current: 0,
            onclick: true,
			onclick2:true,
            zm: 'All'
        }
    },
    created() {
        this.radio1 = this.$route.query.field
        this.radio2 = this.$route.query.category
		this.areaData = this.$route.query.area ? this.$route.query.area : ''
		this.areaData2 = this.$route.query.cit ? this.$route.query.cit : ''
    },
	watch: {
		
		$route(to,from){
			this.areaData = this.$route.query.area ? this.$route.query.area : ''
			this.areaData2 = this.$route.query.cit ? this.$route.query.cit : ''
		}
	},
    methods: {
		
        onClick() {
            this.onclick = false
            setTimeout(() => {
                this.onclick = true
            }, 1000)
        },
		getareaselect(a) {
			for (let key in pca[86]){
				if (pca[86][key] == a) {
					this.edata = pca[key]; 
					break;
				} 
			}
			this.onClick()
			this.$router.push({ name: 'list', query: {field: this.radio1, category: this.radio2, area:a}})
			this.areaData2 = null
			
		},
		getareaselect2 (value){
			console.log(this.areaData,this.areaData2,'areaData')
			this.onClick()
			this.$router.push({ name: 'list', query: {field: this.radio1, category: this.radio2, area:this.areaData, cit:value }})
		},
        getField() {
            this.onClick()
            this.radio2 = '全部'
            this.$router.push({ name: 'list', query: {field: this.radio1, category: this.radio2}})
            this.$store.commit('getField2', this.radio1)

        },
        getCategory() {
            this.onClick()
            this.$router.push({ name: 'list', query: {field: this.radio1, category: this.radio2}})
        },
        getLetter(index) {
            this.onClick()
            this.current = index
            this.$store.commit('getLetter', this.letter[index])
            this.$store.dispatch('getAxios', this.$store.state.parameter)
            this.$store.commit('getPage', 1)

        },
        getLetter2() {
            this.onClick()
            this.$store.commit('getLetter', this.zm)
            this.$store.dispatch('getAxios', this.$store.state.parameter)
            this.$store.commit('getPage', 1)

        },
    }
}
</script>

<style scoped>
.screening {
    max-width: 1160px;
    margin: 20px auto;
    background: #fff;
    padding: 0 20px;
}
.filter {
    display: flex;
    border-bottom: 1px solid rgba(206, 211, 217, .5);
    overflow: hidden;
    position: relative;
    padding: 10px 0;
}
.filter .title {
    flex: 0 0 5%;
    font-size: 14px;
    color: #9da6b2;
    line-height: 38px
}
.letter {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(206, 211, 217, .5);
    padding: 10px 0;
}
.letter a {
    width: 32px;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .3s ease;
}
.letter a:hover {
    color: #409eff;
    background-color: #ecf5ff;
}
.letter .current {
    color: #409eff;
    background-color: #ecf5ff;
}

.mobile-select {
    display: none;
    margin: 10px 0;
}

@media(max-width: 868px) {
    .screening {
        display: none;
    }

    .mobile-select {
        display: flex;
    }
}
</style>